'use client';
import { createStore } from 'zustand/vanilla';
import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { generateId } from './helpers.mjs';

// src/stores/dialog-store.ts
var defaultInitState = {
  items: []
};
var createDialogStore = (initState = defaultInitState) => {
  return createStore()((set) => ({
    ...initState,
    show: (item) => set((state) => ({
      items: [
        ...state.items,
        {
          id: generateId(),
          ...item
        }
      ]
    })),
    hide: (id) => set((state) => ({
      items: state.items.filter(({ id: diffId }) => diffId !== id)
    }))
  }));
};
var DialogContext = createContext(null);
var useDialogStore = (selector) => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error(`useDialogStore must be use within DialogProvider`);
  }
  return useStore(context, selector);
};

export { DialogContext, createDialogStore, defaultInitState, useDialogStore };
